
import React from 'react';
import '../App.css';

function NuestraMision() {
  return (
    <section id="nuestra-mision">
      <div className="content">
        <h2 className="junaeb-title">Nuestra Misión</h2>
        <div className="glass-card">
          <p>
            Somos una escuela pública, con un trabajo pedagógico que posibilita el desarrollo 
            de habilidades artísticas, deportivas y de pensamiento crítico de las y los estudiantes, 
            desde un enfoque socio-constructivista, asegurando la trayectoria educativa de los y las 
            estudiantes mediante la construcción de ambientes de tolerancia y respeto, para aprender 
            a vivir con un sentido de protección y cuidado personal y social.
          </p>
        </div>
      </div>

      <style jsx>{`
        /* Tarjeta con efecto vidrio */
        .glass-card {
          background: rgba(0, 0, 0, 0.35); /* traslúcido */
          border-radius: 16px;
          padding: 30px;
          margin-top: 20px;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }

        .glass-card:hover {
          transform: scale(1.02);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.55);
        }

        /* Título */
        .junaeb-title {
          display: inline-block;
          background: rgba(0, 0, 0, 0.45);
          border-radius: 12px;
          padding: 12px 24px;
          color: #fff;
          font-weight: bold;
          font-size: 1.8rem;
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          margin-bottom: 20px;
        }

        /* Texto principal */
        .glass-card p {
          font-size: 1.5rem; /* ✅ más grande para lectura óptima */
          line-height: 1.9;
          color: #f5f5f5;
          font-weight: 400;
        }
      `}</style>
    </section>
  );
}

export default NuestraMision;
